<template>
  <div class="container">
    <w-navbar v-show="iosOrAndroidShow" nav_title="当前状态" :icon="'iconchevron-left'" :cvShow="true" @mobileLeftBtn="leftBtnClick"/>
    <div class="content">
      <p class="title">你想看的工作类型是（可多选）</p>
      <p class="other">您可以在求职设置中修改您的求职偏好</p>
      <div class="option-content flex-between">
        <div class="option-item" :class="{'active':selectIndex.includes('实习')}" @click="handleClickType('实习')">看实习</div>
        <div class="option-item" :class="{'active':selectIndex.includes('校招')}" @click="handleClickType('校招')">看校招</div>
        <div class="option-item" :class="{'active':selectIndex.includes('社招')}" @click="handleClickType('社招')">看社招</div>
      </div>
      <div class="internship" v-show="selectIndex.includes('实习')">
        <div class="internship-day flex-column">
          <span class="internship-day-title">每周可实习天数</span>
          <p class="internship-day-operation flex-between" @click="handleInterFrequency">
            <!-- <i class="iconfont iconminus-circle" :class="{disabled:intern_frequency==1}"
               @click="handleClickNum(-1)"></i> -->
            <span>{{intern_frequency}} 天</span>
            <i class="iconfont iconchevron-right"></i>
            <!-- <i class="iconfont iconplus-circle" :class="{disabled:intern_frequency==7}"
               @click="handleClickNum(1)"></i> -->
          </p>
        </div>
        <div class="internship-day flex-column">
          <span class="internship-day-title">可实习月份</span>
          <div class="internship-day-operation flex-between">
            <p class="flex-start">
              <span class="select-month margin-16" @click="handleClickPicker(true)">{{start_month.text}}</span>
              <span class="margin-16">至</span>
              <span class="select-month" @click="handleClickPicker(false)">{{end_month.text}}</span>
            </p>
            <i class="iconfont iconchevron-right"></i>
          </div>
        </div>
      </div>
      <!-- <div class="option-item" :class="{'active':selectIndex.includes('兼职')}" @click="handleClickType('兼职')">
        看看兼职机会
      </div> -->
    </div>
    <div class="btn-next" @click="handleClickNext" :style="{background:selectIndex.length>0?'#FF6644':'#CFCFCF'}">
      下一步
    </div>
  </div>
</template>

<script>
  import WNavbar from "@/components/global/w-navbar";
  import {envMixin} from "@/assets/js/mixin/global";
  // import month from "../../assets/json/month.json"
  import {componentsMixin} from "../../assets/js/mixin/components";
  import intention from "../../api/api-list/intention";
  import {mapActions} from "vuex";

  export default {
    name: "student_work_type",
    data() {
      return {
        //选中的标签
        selectIndex: ['实习', '校招','社招'],
        //每周可以实习天数
        intern_frequency: 5,
        //开始月份
        start_month: {text: "开始月份", value: -1},
        //结束月份
        end_month: {text: "结束月份", value: -1},
        //选择器
        addressPicker: null,
        //开始月还是结束月
        isStartMonth: true
      }
    },
    components: {WNavbar},
    methods: {
      ...mapActions('user', ['getUserIntention']),
      //返回
      leftBtnClick() {
        this.$router.back();
      },
      //选中
      handleClickType(type) {
        if (this.selectIndex.includes(type)) {
          for (var i = 0; i < this.selectIndex.length; i++) {
            if (this.selectIndex[i] == type) {
              this.selectIndex.splice(i, 1);
              break;
            }
          }
        } else {
          this.selectIndex.push(type)
        }
      },
      //修改数量
      handleClickNum(num) {
        this.intern_frequency += num
        this.intern_frequency = Math.min(...[this.intern_frequency, 7])
        this.intern_frequency = Math.max(...[this.intern_frequency, 1])
      },
      //
      handleClickPicker(is) {
        this.addressPicker.show()
      },
      // 点击可实习天数
      handleInterFrequency() {
        const pickerData = Array.from({ length: 7 }, (_, index) => {
          return {
            text: `${ index + 1 } 天`,
            value: index + 1
          }
        })
        const index = pickerData.findIndex(item => item.value === this.intern_frequency)
        this.$createPicker({
          data: [pickerData],
          selectedIndex: [index > -1 ? index : 0],
          onSelect: (val) => {
            this.intern_frequency = Number(val.join())
          }
        }).show()
      },
      async handleClickNext() {
        if(this.selectIndex.length==0)return
        if (this.selectIndex.includes('实习')) {
          if (this.start_month.value == -1) {
            this.showToast("请选择实习时间", 1000)
            return
          }
        }

        let expect_work_type = this.selectIndex.map(item => {
          return item
        })
        let intern_frequency = this.intern_frequency;
        let onboard_at = this.start_month.value
        let end_at = this.end_month.value
        let params = {expect_work_type}
        if (this.selectIndex.includes('实习')) {
          params.intern_frequency = intern_frequency
          params.onboard_at = onboard_at
          params.end_at = end_at
        }
        let res = await intention.updateIntentions(params)
        if (res.code === 1000) {
          this.getUserIntention()
          await this.$router.push("/job/intentions")
        } else {
          this.showToast(res.message, 1000)
        }
      },
      selectHandle(selectedVal, selectedIndex, selectedText) {
        this.start_month.text = selectedText[0]
        this.end_month.text = selectedText[2]
        this.start_month.value = selectedVal[0]
        this.end_month.value = selectedVal[2]
      }
    },
    created() {
      let month = []
      let year = new Date().getFullYear()
      let nowMonth = new Date().getMonth()
      for (let i = 0; i < 12; i++) {
        let obj = {
          text: `${year + ((nowMonth + i) > 11 ? 1 : 0)}-${(((nowMonth + i) % 12) + 1).toString().padStart(2, "0")}`,
          value: `${year + ((nowMonth + i) > 11 ? 1 : 0)}-${(((nowMonth + i) % 12) + 1).toString().padStart(2, "0")}-01`,
          children: [
            {
              text: "至",
              value: "",
              children: []
            }
          ]
        }
        for (let j = 0; j < 12; j++) {
          let obj1 = {
            text: `${year + ((nowMonth + i + j + 1) > 11 ? 1 : 0)}-${(((nowMonth + i + j + 1) % 12) + 1).toString().padStart(2, "0")}`,
            value: `${year + ((nowMonth + i + j + 1) > 11 ? 1 : 0)}-${(((nowMonth + i + j + 1) % 12) + 1).toString().padStart(2, "0")}-01`
          }
          obj.children[0].children.push(obj1)
        }
        month.push(obj)
      }
      this.addressPicker = this.$createCascadePicker({
        title: '实习时间',
        data: month,
        onSelect: this.selectHandle,
        selectedIndex:[0,0,2]
      })
      console.log(month)
      this.start_month.text = month[0].text
      this.start_month.value = month[0].value
      this.end_month.text = month[0].children[0].children[2].text
      this.end_month.value = month[0].children[0].children[2].value
      this.selectIndex = this.userIntention.expect_work_type ? this.userIntention.expect_work_type : this.selectIndex
      if(this.selectIndex.includes('实习')){
        this.intern_frequency = this.userIntention.intern_frequency;
        this.start_month.text =this.userIntention.onboard_at.substr(0,7)||month[0].text
        this.start_month.value =this.userIntention.onboard_at||-1
        this.end_month.text =this.userIntention.end_at.substr(0,7)||month[0].children[0].children[2].text
        this.end_month.value =this.userIntention.end_at||-1
      }
    },
    computed: {
      userIntention() {
        return this.$store.state.user.userIntention
      }
    },
    mixins: [envMixin, componentsMixin],
    mounted() {

    }
  }
</script>

<style scoped lang="scss">
  @import '../../assets/scss/global/variable';
  .container {
    height: 100vh;
    position: relative;
    box-sizing: border-box;

    .btn-next {
      width: 327px;
      height: 42px;
      border-radius: 4px;
      color: #fff;
      text-align: center;
      position: absolute;
      left: 24px;
      bottom: 18px;
      line-height: 42px;
      text-align: center;
    }
  }

  .content {
    padding: 88px 24px 0 24px;
    box-sizing: border-box;

    .title {
      font-size: 20px;
      font-weight: 500;
      color: rgba(64, 64, 64, 1);
      margin-bottom: 8px;
    }

    .other {
      font-size: 14px;
      font-weight: 300;
      color: rgba(156, 156, 156, 1);
      margin-bottom: 32px;
    }

    .option-content {
      margin-bottom: 16px;
      .option-item {
        flex: 1;
        height: 36px;
        border-radius: 18px;
        text-align: center;
        line-height: 36px;
        color: #9C9C9C;
        border: 1px solid #ECECEC;
        // &:last-child {
          margin-left: 15px;
        // }
        &:first-child{
          margin: 0;
        }
        &.active {
          color: $color-theme;
          border-color: $color-theme;
        }
      }
    }

    
    .internship {
      border-radius: 4px;
      margin-bottom: 16px;

      .internship-day {
        padding: 18px 0;
        border-bottom: 1px solid #ECECEC;
        .internship-day-title {
          color: $color-dark-gray;
          font-size: $font-size-small;
          margin-bottom: 8px;
          line-height: 17px;
        }

        .internship-day-operation {
          span {
            color: $color-title;
            font-size: 15px;
          }
          i {
            font-size: 18px;
            color: #bcbcbc;
          }
        }
      }

      .internship-month {
        display: flex;
        justify-content: space-between;
        font-size: 14px;
        color: #FF6644;
      }

      .select-month {
        color: #FFC3B5;
      }

      .margin-16 {
        margin-right: 16px;
      }
    }
  }

</style>